import React, {Component} from 'react';
import EditPositionView from "./EditPositionView";
import {Growl} from "primereact/growl";
import {CommonService} from "../../../../service/commons/CommonService";
import {CaptureGuaranteesService} from "../../../../service/ptt/captureGuarantees/CaptureGuaranteesService";
import {withoutComma} from "../../../../utils/calculate/Amount";


export default class EditPositionContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.commonService = new CommonService();
        this.captureGuaranteesService = new CaptureGuaranteesService();
        this.getPositionAccountEmisora = this.getPositionAccountEmisora.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            positionData: this.props.location.state.selectedPosition,
            positionAccount: this.getPositionAccountEmisora(),
            isLoading: true,
        };

        this.onChangeInputText = this.onChangeInputText.bind(this);
        this.editPosition = this.editPosition.bind(this);
        this.makeCalculusPosition = this.makeCalculusPosition.bind(this);
        this.returnCaptureGuaranteesPage = this.returnCaptureGuaranteesPage.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeInputText(event) {
        const {name, value} = event.target;
        let positionDataAux = this.state.positionData;
        positionDataAux[name] = withoutComma(value);
        this.setState({positionData: positionDataAux,});
        this.makeCalculusPosition();
    }

    /**
     * Función que inicializa los valores de la pantalla para editar
     * obtiene los valores que trae de la pantalla anterior y también hace
     * una consulta al back para traer otros valores relacionados con
     * la posición.
     */
    getPositionAccountEmisora() {
        this.loading();
        let idEmission = this.props.location.state.selectedPosition.idEmision;
        let account = this.props.location.state.selectedPosition.cuenta;
        this.captureGuaranteesService.getPositionAccountEmisora(idEmission, account)
            .then(res => {
                let objRes = res[0];
                let positionDataAux = this.state.positionData;
                positionDataAux['posicion'] = objRes['posicion'] ?
                    Number(objRes['posicion']) : '0.0';
                positionDataAux['disponible'] = objRes['disponible'] ?
                    Number(objRes['disponible']) : '0.0';
                positionDataAux['disponibleGarantia'] = objRes['disponibleGarantia'] ?
                    Number(objRes['disponibleGarantia']) : '0.0';
                this.setState({
                    positionData: positionDataAux,
                    isLoading: false,
                });
                this.makeCalculusPosition();
            });
    }

    /**
     * Función que realiza los cálculos de
     * "Posición disponible y Disponible para garantizar"
     * el cálculo se realiza cada vez que se van modificando los valores
     * de entrada de los campos de texto.
     */
    makeCalculusPosition() {
        let positionDataAux = this.state.positionData;
        let availablePosition = Number(positionDataAux['posicion'])
            - Number(positionDataAux['disponibleGarantia'])
            - Number(positionDataAux['disponible']);
        let guaranteeAvailable = Number(positionDataAux['disponibleGarantia'])
            - Number(positionDataAux['garantiasVigentes']);

        positionDataAux['availablePosition'] = availablePosition;
        positionDataAux['guaranteeAvailable'] = guaranteeAvailable;
        this.setState({
            positionData: positionDataAux,
        });
    }

    /**
     * Valida si la posición se válida y si no lo es, manda los mensajes correspondientes a
     * la pantalla.
     * @returns {boolean} booleano que indica si es válida la posición para poder guardarla
     */
    isValidPosition() {
        let isValid = true;
        if (this.state.positionData.posicion === '') {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'La Posición Disponible no puede ir en blanco.'
            });
            isValid = false;
        }
        if (this.state.positionData.availablePosition < 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'La Posición Disponible no puede ser menor a cero.'
            });
            isValid = false;
        }
        if (this.state.positionData.disponibleGarantia === '') {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'El Disponible para Garantizar no puede ir en blanco.'
            });
            isValid = false;
        }
        if (this.state.positionData.guaranteeAvailable < 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'El Disponible para Garantizar no puede ser menor a cero.'
            });
            isValid = false;
        }
        if (this.state.positionData.disponibleGarantia > this.state.positionData.posicion) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'El Total a Garantizar no puede ser mayor a la Posición Total.'
            });
            isValid = false;
        }
        return isValid;
    }

    /**
     * Función que consume a CaptureGuaranteesService para guardar los datos
     * del elemento nuevo.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    editPosition() {
        this.loading();
        if (this.isValidPosition()) {
            this.captureGuaranteesService.saveMttoPosition(this.state.positionData)
                .then(res => {
                        this.returnCaptureGuaranteesPage();
                    }
                );
        }
        this.setState({isLoading: false,})
    }

    /**
     * Función que regresa a la pantalla de Captuera de garantias
     */
    returnCaptureGuaranteesPage() {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {positionData, isLoading} = this.state

        return (
            <EditPositionView
                positionData={positionData}
                messagesGrowl={messagesGrowl}
                isLoading={isLoading}
                onChangeInputText={this.onChangeInputText}
                editPosition={this.editPosition}
                returnCaptureGuaranteesPage={this.returnCaptureGuaranteesPage}
            />
        );
    }
}
